import React, {forwardRef} from 'react'
import tw from 'tailwind-styled-components'
import {Size} from '@components/common/base/buttons/types'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {MenuIconButtonBase} from './menu-icon-button-base'

type Color = 'primary' | 'secondary'
type HoverStyle = 'text' | 'bg'

interface Props {
  icon: TablerIcons
  onClick?: (e: React.MouseEvent) => void
  notification?: boolean
  active?: boolean
  size?: Size
  className?: string
  color?: Color
  hoverStyle?: HoverStyle
}

const circleMixin = `
  after:content-[""]
  after:absolute
  after:top-2
  after:right-2
  after:w-4
  after:h-4
  after:rounded-full
  after:bg-status-error
`

const TwContainer = tw.div<{
  $size: Size
  $color: Color
  $hoverStyle: HoverStyle
  $active?: boolean
  $notification?: boolean
}>`
  rounded-4
  cursor-pointer
  relative

  ${p => {
    const cx: string[] = []
    if (p.$size === 'small') {
      cx.push('p-4')
    } else if (p.$size === 'medium') {
      cx.push('p-6')
    }
    cx.push(
      p.$color === 'primary'
        ? 'text-panel-text-primary'
        : 'text-panel-text-secondary'
    )
    if (p.$hoverStyle === 'text') {
      cx.push('hover:text-action-default')
      if (p.$active) {
        cx.push('!text-action-pressed')
      }
    } else if (p.$hoverStyle === 'bg') {
      if (p.$active) {
        cx.push('bg-panel-background-active')
      } else {
        cx.push('hover:bg-panel-background-hover')
      }
    }
    if (p.$notification) {
      cx.push(circleMixin)
    }
    return cx.join(' ')
  }}
`

export const MenuIconButton = forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const {icon, notification, onClick, active, className} = props
    const {size = 'medium', color = 'primary', hoverStyle = 'bg'} = props

    return (
      <TwContainer
        ref={ref}
        $active={active}
        $notification={notification}
        $size={size}
        $color={color}
        $hoverStyle={hoverStyle}
        onClick={onClick}
        className={className}
      >
        <MenuIconButtonBase icon={icon} size={size} />
      </TwContainer>
    )
  }
)
